import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { DashboardContentLayout } from '~ui-components/components/atoms/dashboard-content-layout';

import { DatasetUpdateSideNav } from './side-nav';

export function DatasetUpdateLayout(props) {
	return (
		<DashboardContentLayout pageTitle="Update">
			<Root {...props} />
		</DashboardContentLayout>
	);
}

function Root(props) {
	const { children } = props;

	return (
		<Box>
			<Stack
				direction={{ xs: 'column', md: 'row' }}
				spacing={4}
				sx={{ position: 'relative' }}
			>
				<DatasetUpdateSideNav />
				<Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{children}</Box>
			</Stack>
		</Box>
	);
}
